// extracted by mini-css-extract-plugin
export default {"bg":"Baccarat_bg__NqQIf","startBetting":"Baccarat_startBetting__i0iBC","blinker":"Baccarat_blinker__dv8Iu","stopBetting":"Baccarat_stopBetting__4kVpK"};